// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3Z3Rt","calendarButtons":"ClockData_calendarButtons__damEk"};